import { PropTypes } from "prop-types";
import { StyledMeetingsList } from "../../styles/StyledMeetingsList";
import { MeetingCard } from "./MeetingCard";

export default function MeetingsList({ data }) {
	return (
		<StyledMeetingsList>
			{data.length > 0 ? data.map((e, i) => <MeetingCard key={i} data={e} />) : <h4>No meetings found</h4>}
		</StyledMeetingsList>
	);
}

MeetingsList.propTypes = {
	data: PropTypes.any,
};
